module.exports = __webpack_public_path__ + "img/img-for-doctor.aa9f7ed.png";